import { graphql } from "babel-plugin-relay/macro";

export const USER_FRAGMENT = graphql`
	fragment contentSubmissionEnd_UserFragment on User {
		id
		...PrivateAddressDialog_UserFragment
	}
`;

export const ANSWERS_RESULTS_QUERY = graphql`
	query contentSubmissionEnd_AnswersResultQuery($submissionId: ID!) {
		LearnV2 {
			GetAnswersResult(submissionId: $submissionId) {
				question
				answers
				correctAnswerIndices
				selectedAnswersIndices
			}
		}
	}
`;

export const CONTENT_SUBMISSION_FRAGMENT = graphql`
	fragment contentSubmissionEnd_ContentSubmissionFragment on ContentSubmission {
		id
		learnOpportunity {
			id
			nextContentNode {
				structureDefinition {
					title
				}
				typeDefinition {
					... on LearnOpportunityELearningContentTypeDefinition {
						containedElementTypes
					}
				}
			}
			... on LearnOpportunityV2 {
				nextContentNode {
					structureDefinition {
						title
					}
				}
				root {
					structureDefinition {
						title
						... on LearnOpportunityRootStructureDefinition {
							tags {
								name
							}
							extension {
								... on LearnOpportunityRootExtensionImpl {
									configConsequences {
										rewardExpired
										showAnswerExpired
									}
								}
							}
						}
					}
				}
			}
			typeDefinition {
				... on LearnOpportunityELearningContentTypeDefinition {
					containedElementTypes
					contentNodeAdvancementResult {
						status
						... on CanNotBeRestartedAfterFailedContentNodeAdvancementResult {
							configResults {
								configType

								... on RestartIfFailedContentConfigResult {
									canBeRestarted
								}

								... on NegativeBlockPermanentlyRestartIfFailedContentConfigResult {
									canBeRestarted
								}

								... on NegativeBlockTemporarilyRestartIfFailedContentConfigResult {
									blockedUntil
								}
							}
						}
					}
				}
			}
			...NavigateDirectToQuestionsAdvanceTreeButton_LearnOpportunityV2Fragment
			...NavigateDirectToQuestionsAdvanceContentButton_LearnOpportunityFragment
		}
		definition {
			status

			... on FailedELearningContentSubmissionDefinition {
				relativeProgress {
					numCorrect
					numElements
					percentageCorrect
				}
			}

			... on PassedELearningContentSubmissionDefinition {
				relativeProgress {
					numCorrect
					numElements
					percentageCorrect
				}
				rewardResults {
					kind
					rewardKind
					... on PharmaPointsRewardWasPossibleResult {
						amount
					}
					... on PacPointsRewardWasPossibleResult {
						amount
					}
					... on FachberaterWasAwardedResult {
						certificateName
						issuedCertificate {
							fileRef {
								url
							}
						}
					}
					... on CertificateRewardWasPossibleResult {
						certificateName
						issuedCertificate {
							fileRef {
								url
							}
						}
					}
				}
			}
		}
		...ContentElementContainer_ContentSubmissionFragment
		...FailedContentButton_ContentSubmissionFragment
		...ProjectContentElementContainer_ContentSubmissionFragment
		...moduleRating_ContentSubmissionFragment
	}
`;
